import { useEffect, useState } from "react";
import { Col, Container, Row, Stack } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DropDownNavigation from "./sidebar/MobileDropdownMenu";

const Header = ({ title, ItemActions }) => {

  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // 
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };


    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container
      fluid
      className="py-2"
      style={{
        //height: "67px",
        background: "white",
        // boxShadow: "1.0px 0.5px 7.0px hsl(0deg 0% 0% / 0.38)",
        borderBottom: '1px solid lightgray'
      }}
    >
      <div className="d-flex justify-content-between align-items-center ">
        <div className="d-flex justify-content-start align-items-center ">
          {isMobile && <DropDownNavigation />}
          <h2 className={`${isMobile ? 'mx-3 bold mt-4' : 'mt-4 bold'}`}>{title}</h2>
        </div>
        <div > {ItemActions}</div>
      </div>


    </Container>
  );
};

export default Header;
